import { useState } from "react";
import {
  getUserEmail,
  createStripeSession,
  createPayPayQrCode,
} from "works/higurashi/utils/api";
import { stripePromise } from "utils/stripe";

// Constants
export const PURCHASE_METHODS = {
  STRIPE: "stripe",
  PAYPAY: "paypay",
};

export const usePurchase = () => {
  const [state, setState] = useState({
    purchaseMethod: null,
    purchaseData: null,
    isProcessing: false,
    emailRequired: false,
    paypayConfirmRequired: false,
  });

  /* Stripe 購入 */
  const purchaseWithStripe = async () => {
    console.log("Starting Stripe purchase with data:", state.purchaseData);
    try {
      const sessionId = await createStripeSession(state.purchaseData);
      const stripe = await stripePromise;

      const { error } = await stripe.redirectToCheckout({
        sessionId: sessionId,
      });

      if (error) {
        console.error("Stripe error:", error);
      }
    } catch (error) {
      console.error("Purchase error:", error);
    }
  };

  /* PayPay 購入 */
  const purchaseWithPayPay = () => {
    // navigate(`/${work}/paypay/ticket-confirm`);
    setState((prev) => ({ ...prev, paypayConfirmRequired: true }));
    window.scrollTo(0, 0);
  };

  const handleConfirmPayPay = () => {
    openPayPayApp();
  };

  const openPayPayApp = async () => {
    try {
      const { data } = await createPayPayQrCode(state.purchaseData);
      window.location.href = data.url;
    } catch (error) {
      console.error("Error creating PayPay QR code:", error);
    }
  };

  const navigateToPurchase = async () => {
    const { purchaseMethod } = state;

    if (purchaseMethod === PURCHASE_METHODS.STRIPE) {
      await purchaseWithStripe();
    } else if (purchaseMethod === PURCHASE_METHODS.PAYPAY) {
      purchaseWithPayPay();
    }
  };

  const handlePurchase = async (method) => {
    setState((prev) => ({
      ...prev,
      isProcessing: true,
      purchaseMethod: method,
    }));

    try {
      const email = await getUserEmail();

      if (!email.emailAddress) {
        setState((prev) => ({
          ...prev,
          emailRequired: true,
          purchaseMethod: method,
          isProcessing: false,
        }));
        window.scrollTo(0, 0);
        return;
      }

      if (method === PURCHASE_METHODS.STRIPE) {
        await purchaseWithStripe();
      } else if (method === PURCHASE_METHODS.PAYPAY) {
        purchaseWithPayPay();
      }
    } catch (error) {
      console.error("Purchase method error:", error);
    } finally {
      setState((prev) => ({ ...prev, isProcessing: false }));
    }
  };

  const setPurchaseData = (data) => {
    setState((prev) => ({ ...prev, purchaseData: data }));
  };

  return {
    ...state,
    handlePurchase,
    navigateToPurchase,
    setPurchaseData,
    handleConfirmPayPay,
  };
};
